/**
 * The Groups workspace's routes (jorigin/brewauth#29 GB1), as a function App
 * calls inside its `<Routes>` so a test can mount exactly these.
 *
 *   /groups, /groups/:id               the workspace (one route, so the list
 *                                      keeps its state as the selection moves)
 *   /admin/groups                  ->  /groups?scope=all
 *   /admin/groups/:id(/:tab)       ->  /groups/:id
 *
 * The old admin group pages are retired (user decision, 2026-09-29; their
 * components were deleted in GB8): their URLs redirect here, so bookmarks
 * keep working. The redirects are not admin-gated: the workspace decides
 * what the caller may see, and a non-admin's `scope=all` is ignored there.
 */
import type { ReactNode } from 'react';
import { Navigate, Route } from 'react-router';
import AdminGroupRedirect from './AdminGroupRedirect';
import { GROUPS_PATH } from './paths';

export function groupsRoutes(workspace: ReactNode) {
  return (
    <>
      <Route path={`${GROUPS_PATH}/:id?`} element={workspace} />
      <Route
        path="/admin/groups"
        element={<Navigate to={{ pathname: GROUPS_PATH, search: '?scope=all' }} replace />}
      />
      <Route path="/admin/groups/:id" element={<AdminGroupRedirect />} />
      <Route path="/admin/groups/:id/:tab" element={<AdminGroupRedirect />} />
    </>
  );
}
